<template>
  <a-drawer
    :title="title"
    :visible="visible"
    :width="900"
    :maskClosable="true"
    placement="right"
    @close="close"
  >
    <div class="drawer-content">
      <div class="container">
        <slot></slot>
      </div>
      <div class="bootom-button">
        <a-popconfirm
          title="确定放弃编辑？"
          @confirm="close"
          okText="确定"
          cancelText="取消"
        >
          <a-button style="margin-right: 0.8rem">取消</a-button>
        </a-popconfirm>
        <a-button @click="handleConfirm" type="primary">提交</a-button>
      </div>
    </div>
  </a-drawer>
</template>

<script>
/**
 * author 周娇
 * desc 侧边抽屉-常用于表单的新增修改
 * params:
 *  title : 抽屉显示的名称
 *  visible : 控制抽屉显示隐藏
 */
import { _throttle } from '@/utils/common';
export default {
  name: 'Drawer',
  props: {
    title: String,
    visible: Boolean,
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit('handleCancel');
    },
    // handleConfirm() {
    //   this.$emit('handleOk');
    // },
    handleConfirm: _throttle((arg) => {
      arg.$emit('handleOk');
    }, 200),
  },
};
</script>

<style lang="less" scoped>
/deep/.ant-drawer-wrapper-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  .ant-drawer-header {
    height: 60px;
  }
  .ant-drawer-body {
    flex: 1;
    padding: 0;
    overflow: hidden;
  }
}
.drawer-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .container {
    flex: 1;
    padding: 24px;
    overflow: auto;
  }
  .bootom-button {
    width: 100%;
    height: 55px;
    line-height: 55px;
    border-top: 1px solid #e8e8e8;
    text-align: right;
    padding-right: 24px;
  }
}
</style>
